import { useSelector } from "react-redux";
import styles from "./Uniter.module.css";
import PropTypes from "prop-types";
import { ReactComponent as SaudiRiyal } from "../../assets/svg/Saudi_Riyal_Symbol.svg";

const Uniter = ({
  children,
  unit,
  unit_bold = false,
  className = "",
  childSize = 12,
  unitSize = 10,
  isBold = false,
  showUnit = true,
  unitColor,
}) => {
  const { currency } = useSelector((store) => store.Login);
  const resolvedUnit = unit || currency;
  const displayUnit =
    resolvedUnit === "SAR" ? (
      <SaudiRiyal height={unitSize} width={unitSize} />
    ) : (
      resolvedUnit
    );


  return (
    <div className={`${styles.UniterContainer} ${className || ""}`}>
      <span
        style={{
          fontSize: childSize,
        }}
        className={`${isBold ? styles.Bold : ""}`}
      >
        {children}
      </span>
      {!!showUnit ? (
        <div
          className={`${styles.Unit} ${unit_bold ? styles.Bold : ""}`}
          style={{ fontSize: unitSize, color: unitColor }}
        >
          {displayUnit}
        </div>
      ) : (
        <></>
      )}
    </div>
  );
};

Uniter.propTypes = {
  children: PropTypes.any,
  unit: PropTypes.string,
  className: PropTypes.string,
};

export default Uniter;